import { render, staticRenderFns } from "./ProfileSuggest.vue?vue&type=template&id=fcb69dd6&"
import script from "./ProfileSuggest.vue?vue&type=script&lang=js&"
export * from "./ProfileSuggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports